/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : NotificationIcon.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useState } from "react";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Notifications from "./Notifications";
import { useDispatch } from "react-redux";
import notificationsAction from "../../redux/actions/notification";
import { HandleApiActions } from "../../redux/actions";
import customConsole from "../../config/customConsole";
import { io } from "socket.io-client";
import { useNavigate } from "react-router-dom";

const NotificationIcon = () => {
  const navigate = useNavigate();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const dispatch = useDispatch();

  // Access notifications from Redux state with safety checks
  const [recentNotificationDetails, setRecentNotificationDetails] = useState(
    []
  );
  const [loadingNotifications, setLoadingNotifications] = useState(false); // New loading state

  const handleBellClick = () => {
    setNotificationOpen((prev) => !prev);
  };

  const handleClose = () => {
    setRecentNotificationDetails([]);
    setNotificationOpen(false);
  };

  const initSocket = () => {
    const socket = io("http://localhost:6005", { transports: ["websocket"] });

    socket.on("connect", () => {
      socket.emit("registerUser", "Rj6GK71ja");
    });

    socket.on("Rj6GK71ja", (msg) => {
      setRecentNotificationDetails([...recentNotificationDetails, msg]);
    });

    socket.on("disconnect", () => {
    });
  };


  const getRecentNotificationDetails = async () => {

    let apiDetails = notificationsAction.get_recent_notifications;

    customConsole({
      ...apiDetails,
      params: {},
      show_toast: false,
    });


    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: {
          ignore_app_loading_spinner: true,
        },
        show_toast: false,
      })
    );

    if (resp.error) {
      setRecentNotificationDetails([]);
    } else {
      setRecentNotificationDetails(resp.data.unread_notifications);
    }
    // setLoadingNotifications(false); // Reset loading state after the call
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={
          // handleBellClick
          () => {
            navigate("/dashboard/notification");
          }
        }
      >
        <Badge
          badgeContent={recentNotificationDetails.length}
          color="error"
          invisible={recentNotificationDetails.length === 0}
        >
          <NotificationsIcon sx={{ color: "grey" }} />
        </Badge>
      </IconButton>

      {notificationOpen && (
        <Notifications
          notifications={recentNotificationDetails}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default NotificationIcon;
